import {serverAPI} from 'features/server/api/serverAPI';

export const useServerAgentToken = (uuid: string, open: boolean) => {
    const {data: server} = serverAPI.useGetServerQuery(uuid, {skip: !open});

    return {server};
};
